export const baseUrl = 'http://localhost:8080/api/n1/';